var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',[_c('v-app-bar',{staticClass:"sticky-top",attrs:{"id":"navbar"}},[_c('AppBar',{staticStyle:{"width":"100%","top":"0"},attrs:{"update":_vm.update},on:{"clicked":_vm.clicked}})],1),_c('main',{staticClass:"LayoutDefault__main"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }